import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import { ProductTestDocumentRowActions } from "../components/ProductTestDocumentsTable"
import { getProductTestDocumentTypeColor, getProductTestDocumentTypeLabel } from "../utils"

import FileChip from "@/components/upload/components/display/FileChip"
import type { SignedUrl } from "@/graphql/codegen/graphql"

interface UseProductTestDocumentColumsProps {
  canDownload: boolean
  canDelete: boolean
  onDelete: (document: SignedUrl) => void
}

export const useProductTestDocumentColumns = ({
  canDownload,
  canDelete,
  onDelete,
}: UseProductTestDocumentColumsProps): ColumnDef<SignedUrl>[] => {
  return [
    {
      accessorKey: "type",
      header: "Type",
      enableSorting: false,
      cell: ({ row }) => (
        <Chip
          label={getProductTestDocumentTypeLabel(row.original.file?.fieldGroup)}
          variant='filled'
          size='small'
          sx={{ backgroundColor: getProductTestDocumentTypeColor(row.original.file?.fieldGroup) }}
        />
      ),
    },
    {
      accessorKey: "originalName",
      header: "File",
      enableSorting: false,
      cell: ({ row }) => <FileChip file={row.original} />,
    },
    {
      accessorKey: "description",
      header: "Description",
      enableSorting: false,
      cell: ({ row }) => row.original.file?.label,
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 72,
      cell: ({ row }) => (
        <ProductTestDocumentRowActions row={row} canDownload={canDownload} canDelete={canDelete} onDelete={onDelete} />
      ),
    },
  ]
}
